var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g({staticClass:"white--text",attrs:{"small":"","color":"geoportal","loading":_vm.loading,"disabled":!_vm.disabled}},_vm.$listeners),[_vm._v(_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }